import { useContext, useEffect, useRef } from 'react';
import { StepperContext } from '@digitools/honest-react';
const usePageFocus = () => {
    const ref = useRef(null);
    const { currentStep } = useContext(StepperContext);
    useEffect(() => {
        if (ref.current?.offsetParent !== null) {
            ref.current?.focus();
        }
    }, [currentStep]);
    return ref;
};
export default usePageFocus;
